















import { Component, Prop, Vue } from "vue-property-decorator";
import MissingBannersSummary from "./MissingBannersSummary.vue";
import MissingBannersDetails from "./MissingBannersDetails.vue";
import ReportsAPI from "@/services/reports";
import { MissingBannersReport } from "@/models/reports";
import { LayoutModule } from "@/store/layout";
import DefinitionsAPI from "@/services/definitions";
import { DefinitionList } from "@/models/definition";
import { QueryParams } from "@/models/general";
import SitesAPI from "@/services/sites";
import Site from "@/models/site";
@Component({
  components: {
    MissingBannersSummary,
    MissingBannersDetails,
  },
})
export default class MissingBanners extends Vue {
  @Prop({ default: false }) summary!: boolean;

  data: MissingBannersReport[] = [];
  definitions: DefinitionList[] = [];
  sites: Site[] = [];

  async created(): Promise<void> {
    LayoutModule.showLoader();
    await this.getReportData();
    await this.getDefinitions();
    await this.getSites();
    LayoutModule.hideLoader();
  }

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  async getReportData(): Promise<void> {
    try {
      const r = await ReportsAPI.missingBanners();
      this.data = r;
    } catch (e) {
      console.log(e);
    }
  }

  async getSites(): Promise<void> {
    const params: QueryParams = {
      page: {
        size: -1,
      },
    };
    const r = await SitesAPI.getSites(params);
    this.sites = r.data;
  }

  async getDefinitions(): Promise<void> {
    try {
      const r = await DefinitionsAPI.list(-1, -1);
      this.definitions = r.data;
    } catch (e) {
      console.log(e);
    }
  }
}
